import Reveal from "@/components/base/Reveal";
import { allServices } from "@/mocks/services";
import { dentistAdvantages, dentistSolutions, dentistWorkflow } from "@/mocks/dentists";
import { site } from "@/mocks/site";

const partnerWhatsapp = `${site.whatsappBase}${encodeURIComponent(
  "Diş hekimi olarak görüntüleme iş ortaklığı hakkında bilgi almak istiyorum.",
)}`;

export default function DentistOverview() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="shell">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-14">
          <article className="lg:col-span-8">
            <Reveal>
              <h2 className="font-heading text-2xl font-medium tracking-tight text-foreground-950 md:text-3xl">
                Kliniğiniz için neden d.mar?
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                Yıllardır İstanbul'daki çok sayıda diş kliniğinin görüntüleme partneri olarak
                çalışıyoruz. Kendi kliniğinizde çekemeyeceğiniz ya da zaman alacak CBCT, sefalometrik
                ve TME gibi ileri görüntülemeleri hızlı, doğru ve güvenilir şekilde sizin adınıza
                yapıyor; raporları dijital olarak size teslim ediyoruz.
              </p>

              <h3 className="mt-9 font-heading text-lg font-medium tracking-tight text-foreground-950">
                Diş hekimlerine sunduğumuz avantajlar
              </h3>
              <ul className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
                {dentistAdvantages.map((item) => (
                  <li
                    key={item.title}
                    className="relative overflow-hidden rounded-xl border border-background-200 bg-background-100 p-4"
                  >
                    <span
                      className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                      aria-hidden="true"
                    />
                    <p className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                      <i className="ri-check-line text-base text-primary-600" aria-hidden="true" />
                      {item.title}
                    </p>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal>
              <h2 className="mt-14 font-heading text-2xl font-medium tracking-tight text-foreground-950 md:text-3xl">
                İş akışı: Sevk nasıl çalışır?
              </h2>
              <ol className="mt-6 flex flex-col gap-4">
                {dentistWorkflow.map((step) => (
                  <li key={step.step} className="relative flex gap-4 overflow-hidden rounded-xl border border-background-200 bg-background-100 p-5">
                    <span
                      className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                      aria-hidden="true"
                    />
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-semibold text-background-50">
                      {step.step}
                    </span>
                    <div>
                      <h3 className="font-heading text-base font-medium text-foreground-950">{step.title}</h3>
                      <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.text}</p>
                    </div>
                  </li>
                ))}
              </ol>
            </Reveal>

            <Reveal>
              <h2 className="mt-14 font-heading text-2xl font-medium tracking-tight text-foreground-950 md:text-3xl">
                Kliniğinize özel çözümler
              </h2>
              <ul className="mt-6 flex flex-col divide-y divide-background-200 overflow-hidden rounded-xl border border-background-200 bg-background-50">
                {dentistSolutions.map((item) => (
                  <li key={item.title} className="p-5 transition-colors hover:bg-background-100/60 md:p-6">
                    <h3 className="font-heading text-base font-medium text-foreground-950">{item.title}</h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </li>
                ))}
              </ul>
            </Reveal>

            <Reveal>
              <h2 className="mt-14 font-heading text-2xl font-medium tracking-tight text-foreground-950 md:text-3xl">
                İletişim ve fiyatlandırma
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                İş birliği detayları, fiyatlandırma ve özel istekleriniz için WhatsApp'tan veya
                telefonla bize ulaşın. Düzenli çalışan kliniklere özel paket fiyat sunulur.
              </p>
            </Reveal>
          </article>

          <aside className="lg:col-span-4">
            <div className="flex flex-col gap-5 lg:sticky lg:top-28">
              <Reveal>
                <div className="relative overflow-hidden rounded-xl border border-primary-900 bg-primary-950 p-6">
                  <span
                    className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                    aria-hidden="true"
                  />
                  <h3 className="flex items-center gap-2 font-heading text-base font-medium text-background-50">
                    <i className="ri-team-line text-base text-accent-400" aria-hidden="true" />
                    İş Birliği İçin
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-background-200/85">
                    Kliniğiniz için görüntüleme partnerliği detaylarını konuşalım. WhatsApp'tan yazın,
                    aynı gün dönüş yapalım.
                  </p>
                  <div className="mt-5 flex flex-col gap-2.5">
                    <a
                      href={partnerWhatsapp}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
                    >
                      <i className="ri-whatsapp-line text-base" aria-hidden="true" />
                      WhatsApp'tan Yaz
                    </a>
                    <a
                      href={site.phoneMainHref}
                      className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
                    >
                      <i className="ri-phone-line text-base" aria-hidden="true" />
                      Telefonla Bilgi Al
                    </a>
                  </div>
                </div>
              </Reveal>

              <Reveal delay={80}>
                <div className="relative overflow-hidden rounded-xl border border-background-200 bg-background-100 p-6">
                  <span
                    className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                    aria-hidden="true"
                  />
                  <h3 className="font-heading text-base font-medium text-foreground-950">Hizmet Kataloğu</h3>
                  <ul className="mt-4 flex flex-col gap-2.5">
                    {allServices.map((service) => (
                      <li key={service.slug}>
                        <a
                          href="/hizmetler"
                          className="flex items-center gap-2.5 text-sm text-foreground-700 transition-colors hover:text-primary-700"
                        >
                          <i className={`${service.icon} text-base text-primary-600`} aria-hidden="true" />
                          {service.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>

              <Reveal delay={140}>
                <div className="relative overflow-hidden rounded-xl border border-background-200 bg-background-100 p-6">
                  <span
                    className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent-400/60 to-transparent"
                    aria-hidden="true"
                  />
                  <h3 className="flex items-center gap-2 font-heading text-base font-medium text-foreground-950">
                    <i className="ri-lock-2-line text-base text-primary-600" aria-hidden="true" />
                    Gizlilik &amp; KVKK
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    Hastalarınızın görüntü ve raporları, hasta mahremiyeti ve KVKK kapsamında güvenle
                    saklanır. Anlaşmalı klinikler için DICOM bulut erişimi şifreli olarak sağlanır.
                  </p>
                </div>
              </Reveal>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}